import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import { DialogoLancamentoProps } from "../../relacao-pagamentos.types"
import { DialogForm } from "./dialog-form"

export function DialogoLancamento({
  payment,
  open,
  onClose,
  onSave,
  onDelete,
  mode = "view",
}: DialogoLancamentoProps) {
  if (!payment) return null

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogTitle />
      <DialogContent className="bg-darkblue rounded-lg p-0 max-w-2xl max-h-[85vh] overflow-hidden border border-gray-700/50">
        <div className="p-6 md:p-8 overflow-y-auto max-h-[85vh]">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-white">
              {payment.number} - Lançamento
            </h3>
          </div>

          <DialogForm
            payment={payment}
            isEditing={mode === "edit"}
            onSave={onSave}
            onDelete={onDelete}
            onClose={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
